/**
 * Export component file to be used on project
 */

import ForgotPassword from './ForgotPassword';
export default ForgotPassword;